package pwgs.ui.scenes.projectrootscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(ProjectRootSceneProps::class, ProjectRootSceneModel::class)
interface ProjectRoot {
    fun load()
}

@Serializable
class ProjectRootSceneProps(val projectId: Long)

@Serializable
class ProjectRootSceneModel() {
    var isLoading = true
    var hasPermission = false
}